module.exports = __webpack_public_path__ + "static/media/image_4.f8f354fd.png";